var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-container d-flex justify-center align-center"},[_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100","color":"secondary"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }